import { render, staticRenderFns } from "./CardProfissional.vue?vue&type=template&id=00297774&scoped=true"
import script from "./CardProfissional.vue?vue&type=script&lang=js"
export * from "./CardProfissional.vue?vue&type=script&lang=js"
import style0 from "./CardProfissional.vue?vue&type=style&index=0&id=00297774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00297774",
  null
  
)

export default component.exports